const TYPES = {
  SET_ASYNC_FILTER_VALUES: 'SET_ASYNC_FILTER_VALUES'
};

export default TYPES;
